// src/services/tenantContext.js
//
// Tiny module-level accessor for the current user's tenantId. Services
// can't consume React hooks, so AuthContext writes the tenantId here
// whenever the user profile loads and services read it back when they
// build Firestore queries. Firestore security rules require every list
// query to be constrained by the tenant, so every multi-tenant-aware
// service must include `where('tenantId', '==', getCurrentTenantId())`.

let _tenantId = null;

export const setCurrentTenantId = (id) => {
  _tenantId = id || null;
};

export const getCurrentTenantId = () => _tenantId;

/**
 * Convenience helper: throws a helpful error when a query requires a
 * tenant but none is set (usually means the caller ran before auth
 * profile finished loading).
 */
export const requireTenantId = () => {
  if (!_tenantId) {
    throw new Error(
      'No tenant context available. Wait for AuthContext.authReady before querying.',
    );
  }
  return _tenantId;
};
